var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreaChartAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33332 0H0V49.9999H49.9999V48.3543C50 48.3473 50 48.3402 50 48.3332V8.33331C50 7.41284 49.2538 6.66665 48.3333 6.66665C47.4129 6.66665 46.6667 7.41284 46.6667 8.33331C46.6667 15.603 45.0492 21.1065 42.7575 24.7349C40.4581 28.3757 37.5895 29.9999 35 29.9999C33.9308 29.9999 32.8603 29.4746 31.6513 28.3586C30.4307 27.2318 29.2739 25.6983 28.0001 23.9999L27.9477 23.9301C26.7356 22.3139 25.4095 20.5456 23.943 19.1919C22.4437 17.8079 20.5975 16.6666 18.3334 16.6666C14.0063 16.6666 11.0749 19.9364 9.31042 23.9064C7.52084 27.9329 6.66678 33.1813 6.66678 38.3332V38.9906C6.66678 41.798 5.43477 44.4422 3.33332 46.2458V0Z",
    fill: "#E01A4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChartAlt);
export default __webpack_public_path__ + "static/media/area-chart-alt.f45b06fb263e05066dab68ab2e3797b5.svg";
export { ForwardRef as ReactComponent };